import React from "react";
import dayjs from "dayjs";
import './styles.scss'

import {Timeline, Text} from '@mantine/core';
import { IShipmentMilestone } from "../../../api/Shipment.Milestones/Shipment.Milestones.types";

interface Props {
    milestones: IShipmentMilestone[]
}

function ShipmentTimeline ({milestones}: Props) {
    function RenderItems() {
        if(!milestones) return (<div>No Milestones to Display</div>);
        
        return milestones.map((milestone, index) => {
            return(
                <Timeline.Item title={milestone.eventName} key={index}>
                    {milestone.actualEstimate.toLowerCase() === 'a' &&
                        <Text size="sm">
                            Actual Date:&nbsp;
                            {dayjs(milestone.eventDate).format('ddd MMM DD, YYYY')}
                        </Text>}
                    {milestone.actualEstimate.toLowerCase() === 'e' &&
                    <Text size="sm">
                        Estimated Date:&nbsp;
                        {dayjs(milestone.eventDate).format('ddd MMM DD, YYYY')}
                    </Text>}
                </Timeline.Item> 
            )
        })
    }

    function GetActiveIndex() {
        let activeIndex = 0;
        if(!milestones) return activeIndex;

        for(let i = 0; i < milestones.length; i++) {
            if(milestones[i].eventDate) {
                activeIndex = i;
            }
        }
        return activeIndex;
    }

    return (
        <div style={{marginTop:24}} className="milestones-shipment"> 
            <Timeline active={GetActiveIndex()} bulletSize={20} lineWidth={4}>
                {RenderItems()}
            </Timeline>
        </div>
    )
}

export default ShipmentTimeline;